<template>
  <SectionBasicLayout title="settings.title">
    <template #content>

      <UserAvatar></UserAvatar>

      <h3>
        {{ Language.say('settings.menu.configuration') }}
      </h3>

      <nav class="menu">
        <ul>
          <li class="menu-item">
            <a @click="onOpenSettingsWizard()" target="_blank" role="button">
              <span class="menu-title">
                {{ Language.say('settings.menu.wizard') }}
              </span>
            </a>
          </li>
          <li class="menu-item" v-if="AccountController.checkPermissions('premium')">
            <a @click="onOpenWhatsNew()" target="_blank" role="button">
              <span class="menu-title">
                {{ Language.say('settings.menu.whats_new') }}
              </span>
            </a>
          </li>
        </ul>
      </nav>

      <h3>
        {{ Language.say('settings.menu.my_account') }}
      </h3>

      <nav class="menu">
        <ul>
          <li v-for="item in account_items" :key="item.text" class="menu-item">
            <a :href="item.link" target="_blank">
              <span class="menu-title">
                {{ Language.say(item.text) }}
                <i class="fas fa-external-link-alt"></i>
              </span>
            </a>
          </li>
        </ul>
      </nav>

      <UserQuota></UserQuota>

      <div v-for="section in settings_items" :key="section.title">
        <h3>{{ Language.say(section.title) }}</h3>

        <nav class="menu">
          <ul>
            <li v-for="item in section.items" :key="item.text" class="menu-item active">
              <router-link :to="item.link">
                <span class="menu-title">
                  {{ Language.say(item.text) }}
                </span>
                <!-- <span class="badge-new">Novo</span> -->
                <span v-if="item.premium === true && AccountController.account.premium.upgrade === true"  class="button-premium" v-tooltip='"SAPO Mail Premium"'></span>
              </router-link>
            </li>
          </ul>
        </nav>
      </div>
    </template>
  </SectionBasicLayout>
</template>

<script setup>
    import {onBeforeMount, ref}  from 'vue'
    import {defineProps}         from 'vue'
    import SectionBasicLayout    from '@/vue/Layouts/Sections/SectionBasicLayout.vue';
    import UserAvatar            from '@/vue/Views/Webmail/Partials/UserAvatar.vue';
    import UserQuota             from '@/vue/Views/Webmail/Partials/UserQuota.vue';
    import AccountController     from '@/js/Webmail/AccountController';
    import Language              from '@/js/Shared/Language/Language';
    import SAPOMailConfig        from '@/SAPOMailConfig';

    const props = defineProps({
        webmail_view: {},
    })

    const account_items = [
    {
        'link': SAPOMailConfig.server.external_links.sso_profile,
        'text': 'settings.menu.sso_profile',
    },
    {
        'link': SAPOMailConfig.server.external_links.password_reset,
        'text': 'settings.menu.password_reset',
    },
    {
        'link': SAPOMailConfig.server.external_links.manage_recover,
        'text': 'settings.menu.manage_recover',
    },
    ];

    const settings_items = ref([
    {
        'title': 'settings.menu.email',
        'items': [
            {
                'link'   : '/settings/identities',
                'text'   : 'settings.menu.identities',
                'premium': false,
            },
            {
                'link'   : '/settings/messages_options',
                'text'   : 'settings.menu.messages',
                'premium': false,
            },
            {
                'link'   : '/settings/out_of_office',
                'text'   : 'settings.menu.out_of_office',
                'premium': false,
            },
            {
                'link'           : '/settings/messages_forwarding',
                'text'           : 'settings.menu.forwarding',
                'premium'        : true,
                'permission_type': 'premium',
                'permission'     : 'max_forward_emails'
            },
            {
                'link'           : '/settings/kids',
                'text'           : 'settings.menu.kids',
                'premium'        : false,
                'permission_type': 'kids',
                'permission'     : null,
            }
        ],
    },

    {
        'title': 'settings.menu.security',
        'items': [
            {
                'link'   : '/settings/imap',
                'text'   : 'settings.menu.imap_block',
                'premium': true,
            },
            {
                'link'           : '/settings/smokescreen_addresses',
                'text'           : 'settings.menu.smokescreen_addresses',
                'premium'        : true,
                'permission_type': 'cos',
                'permission'     : 'max_smokescreen_addresses'
            },
        ],
    },
    {
        'title': 'Anti-Spam',
        'items': [
            {
                'link'           : '/settings/allowed_emails',
                'text'           : 'settings.menu.allowed_emails',
                'premium'        : false,
                'permission_type': 'cos',
                'permission'     : 'max_whitelist_entries'
            },
            {
                'link'           : '/settings/blocked_emails',
                'text'           : 'settings.menu.blocked_emails',
                'premium'        : false,
                'permission_type': 'cos',
                'permission'     : 'max_blacklist_entries'
            },
        ],
    },
    {
        'title': 'settings.menu.more_options',
        'items': [
            {
                'link'           : '/settings/filters',
                'text'           : 'settings.menu.filters',
                'premium'        : false,
                'permission_type': 'cos',
                'permission'     : 'max_sieve_filters'
            },
            {
                'link'   : '/settings/notifications',
                'text'   : 'settings.menu.notifications',
                'premium': false,
            },
            {
                'link'   : '/settings/housekeeper',
                'text'   : 'settings.menu.housekeeper',
                'premium': false,
            },
            {
                'link'   : '/settings/layout',
                'text'   : 'settings.menu.layout',
                'premium': false,
            },
        ],
    },
    ])

    onBeforeMount(() => {
        setMenus();
    });

    const onOpenSettingsWizard = () => {
        props.webmail_view.openModal('SETTINGS_WIZARD');
    }

    const onOpenWhatsNew = () => {
        props.webmail_view.openModal('SETTINGS_WHATS_NEW');
    }

    const setMenus   = () => {
        settings_items.value.forEach(section => {
            section.items = section.items.filter(item => {
                if (!item.permission_type) {
                    return true
                }

                return AccountController.checkPermissions(item.permission_type, item.permission);
            });
        })
    }
</script>
